import { render } from "./IconFilePlus.vue?vue&type=template&id=80312aaa"
const script = {}

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__